import { type FC } from 'react';
import { FormattedMessage } from 'dibs-react-intl';

import dibsCss from 'dibs-css';

export const newArrivalsVariantTitle = (
    <FormattedMessage
        id="homepage.modules.newArrivalsVariant.title"
        defaultMessage="New Arrivals"
    />
);

export const DiveBackIntoYourFavoritesItalic: FC<{ isMobile: boolean }> = ({ isMobile }) => (
    <FormattedMessage
        id="HpSharedRecentlyFavoritedCarousel.diveBackIntoYourFavorites.italic"
        defaultMessage="Dive Back Into <italicWrapper>Your Favorites</italicWrapper>"
        values={{
            italicWrapper: (chunks: React.ReactNode) => (
                <span
                    className={
                        isMobile
                            ? dibsCss.sassyFontHeaderLargeItalic
                            : dibsCss.sassyFontHeaderXLargeItalic
                    }
                >
                    {chunks}
                </span>
            ),
        }}
    />
);
